import { Icons } from "../../Everou/_assets";
import { forwardRef, RefObject } from "react";

type CustomCardProps = {
    children: any;
    className?: string;
    selected?: boolean;
    banner?: any;
    banner2?: any;
    compact?: boolean;
    style?: React.CSSProperties;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    ref?: RefObject<any>
    bannerBackground?: string;
    battery?: number;
    wifi_rssi?: number;
    /** The device is online through its SIM: the signal icon is the
     *  cellular one, not the WiFi one. */
    onSim?: boolean;
};

export const CustomCard = forwardRef(({
    children,
    selected = false,
    className,
    banner,
    banner2,
    compact = false,
    style,
    bannerBackground,
    battery,
    wifi_rssi,
    onSim = false,
    onClick,
    onMouseEnter,
    onMouseLeave,
}: CustomCardProps, ref: any) => {
    return (
        <div
            onMouseEnter={onMouseEnter && onMouseEnter}
            onMouseLeave={onMouseLeave && onMouseLeave}
            ref={ref}
            style={{ ...style }}
            className={`${className ?? ""}  ${selected
                    ? "c-z-index-100 c-bd-left-primary-large c-bd-primary"
                    : ""
            } ${!!onClick ? "c-hover-box-shadow cp" : ""} ${
                compact ? "pt-2 pb-2" : banner ? "pb-4 pt-3" : "pt-3 pb-4"
            } c-transition-fast c-h-min px-3 c-rounded-1rem position-relative bg-white c-bd-220`}
            onClick={onClick ? onClick : () => {}}
        >
            {(!!battery || !!wifi_rssi) && (<div className=" c-absolute-tr text-center d-flex align-items-center justify-content-end" style={{paddingRight:"5px"}}>
                {!!battery && (<>
                    <small style={{color: battery<=30? "red": "#828282"}}>{battery}%</small>
                    <img
                        className={`${"c-img-1-25rem"}`}
                        src={battery <= 30 ? Icons.battery_low:Icons.battery}
                        />
                </>)}
                {!!wifi_rssi && (
                    <img
                        className={`${"c-img-1-25rem"}`}
                        src={wifi_rssi == 1 ? Icons.wifi_no_connection : onSim ? Icons.sim_connection : Icons.wifi_connection}
                        />
                )}
            </div>)}
            <div className="position-relative" style={{paddingTop: compact ? "2px" : "5px"}}>{children}</div>
            {!!banner && (
                <small className=" c-absolute-br text-center">
                    <div
                        style={{
                            minWidth: "80px",
                            fontSize: "10px",
                            display: "flex",
                            flexDirection: "row-reverse",
                        }}
                    >
                        <div style={{ zIndex: 2, paddingTop: '2px', backgroundColor:bannerBackground?bannerBackground:'' }} className="px-4 c-bg-grey-240 c-rounded-tl-1rem c-rounded-br-1rem">{banner}</div>
                        {!!banner2 && (
                            <small
                                style={{
                                    minWidth: "80px",
                                    fontSize: "10px",
                                    whiteSpace: "nowrap",
                                    paddingTop: '2px',
                                    paddingRight: '28px !important',
                                    marginRight: '-12px',
                                    zIndex: 1
                                }}
                                className="c-bg-grey-250 px-4 c-rounded-tl-1rem text-center"
                            >
                                {banner2}
                            </small>
                        )}
                    </div>
                </small>
            )}
        </div>
    );
}) 
